import { render, staticRenderFns } from "./ExamCreate.vue?vue&type=template&id=9cf0e268&"
import script from "./ExamCreate.vue?vue&type=script&lang=js&"
export * from "./ExamCreate.vue?vue&type=script&lang=js&"
import style0 from "./ExamCreate.vue?vue&type=style&index=0&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports